import {Box, HBox} from '@buncha/components/core/view';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {CustomImage} from '@buncha/components/core/Image';
import {H5Text} from '@buncha/components/core/text';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

const TipComponent: React.FC = () => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const {body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};
  return (
    <Box
      style={[
        styles.tipContainer,
        {
          backgroundColor: theme?.background.blue[200],
          borderColor: theme?.background.blue[100],
        },
      ]}>
      <HBox style={styles.container}>
        <CustomImage
          style={styles.imageStyle}
          resizeMode="cover"
          source={require('@buncha/resource/images/TipDollar.png')}
        />
        <H5Text
          style={[
            styles.renderDetailsValueText,
            {
              color: theme?.text.blue[300],
              fontFamily: muliFont[600].normal,
            },
          ]}>
          {body?.tipMessage}
        </H5Text>
      </HBox>
    </Box>
  );
};

export default React.memo(TipComponent);
